import {useState, useEffect} from "react";
import RCPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import PC from "../PC";
import Mobile from "../Mobile";
import Button from "../Button";
import {useTranslation} from "react-i18next";

export default function Pagination({ className, total, current, onChange, pageSize = 10 }) {
  const { t } = useTranslation();
  
  const pageCount = Math.ceil(total / pageSize);
  
  const options = Array.from({ length: pageCount }).map((item, i) => i += 1);
  
  const selectPage = async (e) => {
    await onChange(Number(e.target.value));
    window.scrollTo(0, 0);
  };
  
  const moilePageHandle = async (type) => {
    let num = type === 'prev' ? current -= 1 : current += 1;
    await onChange(num);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  
  return (
    <>
      <PC className={`text-center ${className}`}>
        <RCPagination
          className="demo1-pagination"
          current={current}
          total={total}
          pageSize={pageSize}
          onChange={onChange}
        />
      </PC>
      <Mobile className={`text-center mdmax:pt-[12px] mdmax:pb-[50px] ${className}`}>
        {
          current > 1 &&
          <Button
            onClick={()=>moilePageHandle('prev')}
            className="rounded-[5px] bg-[#eece7a] h-[32px] text-[13px] px-[12px] mr-[10px]">{t('上一页')}</Button>
        }
        {
          current < pageCount &&
          <Button
            onClick={()=>moilePageHandle('next')}
            className="rounded-[5px] bg-[#eece7a] h-[32px] text-[13px] px-[12px] mr-[15px]">{t('下一页')}</Button>
        }
        
        <select
          onChange={selectPage}
          value={current}
          className="bg-[#fff] w-[90px] h-[32px] text-center text-[14px] rounded-[5px] border-[1px] border-[#c7c7c7]">
          {
            options.map((count) => (
              <option key={count}
                      value={count}>
                {count} / {pageCount}
              </option>
            ))
          }
        </select>
      </Mobile>
    </>
  );
}
